import React from 'react'
import { Collapse, Container } from 'react-bootstrap'
import { FormikProvider } from 'formik'
import { useTranslation } from 'react-i18next'

export function Database ({ formik, section, componentData, getRow }) {
  const { t } = useTranslation()
  return (
    <FormikProvider value={formik}>
      <Container fluid>
        <h2>{t('Connection Type')}</h2>
        {getRow(section, 'dbSimple', 'checkbox')}
        <h2>{t('DB Type')}</h2>
        {getRow(section, 'DBType', 'select', componentData[section][0][2])}
        <Collapse in={parseInt(formik.values[section + '_DBType']) === 4}>
          <Container fluid>
            {componentData[section].map(v => ['DBSyntax', 'ODBCCompatibilityMode'].indexOf(v[0]) > -1 ? getRow(section, v[0], v[1], v[2]) : null)}
          </Container>
        </Collapse>
        {getRow(section, 'DatabaseName', 'text')}
        {getRow(section, 'Options', 'text')}
        <Collapse in={parseInt(formik.values[section + '_DBSyntax']) === 2 || parseInt(formik.values[section + '_DBType']) !== 4}>
          <Container fluid>
            {componentData[section].map(v => ['UserName', 'Password'].indexOf(v[0]) > -1 ? getRow(section, v[0], v[1], v[2]) : null)}
          </Container>
        </Collapse>
        <Collapse
          in={!(!!formik.values['DBSettings_dbSimple'] || [1, 4].indexOf(parseInt(formik.values[section + '_DBType'])) > -1)}>
          <Container fluid>
            {componentData[section].map(v => ['HostName', 'Port', 'Schema'].indexOf(v[0]) > -1 ? getRow(section, v[0], v[1], v[2]) : null)}
          </Container>
        </Collapse>
        <h2>{t('Other DB Settings')}</h2>
        {getRow(section, 'permanentConnections', 'checkbox')}
        {getRow(section, 'DBConnectionTimeout', 'text')}
        {getRow(section, 'maxPoolSize', 'text')}
        {getRow(section, 'SqlMaxLimit', 'text')}
        {getRow(section, 'PostQuery', 'text')}
        {getRow(section, 'cacheDir', 'text')}
        {getRow(section, 'PostQuery', 'text')}
      </Container>
    </FormikProvider>
  )
}